import { Injectable, signal } from '@angular/core';
import { FormMode } from 'src/app/controls/common/form-mode';
import { RestApiConfiguration } from 'src/app/models/RestApiCaller/configuration/rest-api-configuration';
import { MultiLevelContextMenuItem } from '../../common/models/multi-level-context-menu-item';

@Injectable()
export class ApiConfigurationState {
    /**
     * Définit le mode du formulaire (Création / Edition / lecture).
     */
    public $mode = signal<FormMode>(FormMode.Reading);

    /**
     * Définit la configuration de l'API initiale (avant modification).
     */
    public initialApiConfiguration: RestApiConfiguration = null;

    /**
     * Définit la configuration de l'API.
     */
    public $apiConfiguration = signal<RestApiConfiguration>(null);

    /**
     * Définit la liste des éléments du menu contextuel des variables.
     */
    public variableContextMenuItems: MultiLevelContextMenuItem = null;
}
